import React from 'react';
import Routers from './routers';

//bootstrap
import 'bootstrap/dist/js/bootstrap.bundle';

function App() {
  return (
    <>
      <Routers />
    </>
  );
}

export default App;
